import fetchApi from 'components/utils/fetch_api'

const getCurrentTradingLimits = currencyCode => {
  return fetchApi('trading/cw/trading_limits/current', { params: { currency_code: currencyCode } }).then(
    res => res?.data,
  )
}

export { getCurrentTradingLimits }
